import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';

import { useState } from 'react';
import { useIntl } from 'react-intl';
import Button from '../../../../react-components/Button';
import Text from '../../../../react-components/Text';
import eventsPanel from '../../../../services/events';
import { AnimatedStep } from '../AnimatedStep';
import { LocationInputsProps, VehiclesLocationInputs } from './VehiclesLocationInputs';

interface VehiclesLocationProps {
  vehiclesLocation?: LocationInputsProps;
  onChange: (vehiclesLocation: LocationInputsProps) => void;
  onNextStep: () => void;
}

export const VehiclesLocation = ({ vehiclesLocation, onChange, onNextStep }: VehiclesLocationProps) => {
  const intl = useIntl();
  const [animationVisible, setAnimationVisible] = useState<boolean>(true);
  return (
    <AnimatedStep id="vehiclesLocationAnimatedContainer" isVisible={animationVisible}>
      <Grid
        container
        direction="column"
        wrap="nowrap"
        style={{ padding: `20px`, maxWidth: `660px`, position: `relative` }}
      >
        <Grid item>
          <Text variant="h6" intlId="company.onboarding.vehicles.location.info" />
        </Grid>

        <VSpacer medium />

        <VehiclesLocationInputs vehiclesLocation={vehiclesLocation} onChange={onChange} />

        <VSpacer small />

        <Grid item>
          <Text variant="label" style={{ fontSize: `11px` }}>{`*${intl.formatMessage({
            id: `company.onboarding.vehicles.location.hint`,
          })}`}</Text>
        </Grid>

        <Grid
          item
          container
          direction="row"
          wrap="nowrap"
          alignItems="center"
          justifyContent="center"
          style={{ position: `absolute`, bottom: `-60px` }}
        >
          {vehiclesLocation?.start !== undefined && (
            <Button
              intlId="company.onboarding.next"
              style={{
                width: `200px`,
                height: `32px`,
              }}
              onClick={() => {
                setAnimationVisible(false);
                setTimeout(() => {
                  onNextStep();
                  eventsPanel.onboardingPageView({
                    page: `vehiclesLocation`,
                    data: { startLocation: vehiclesLocation.start?.label, endLocation: vehiclesLocation.end?.label },
                  });
                }, 500);
              }}
            />
          )}
        </Grid>
      </Grid>
    </AnimatedStep>
  );
};
